import { isDate, parse } from 'date-fns';
import * as yup from 'yup';

/**
 * Parses dates using date-fns instead of the native Date object since the native one has issues with dates prior to year 100
 * (for example 0050-10-10 gets parsed as the year 1950)
 */
export const dateValidator = yup.date().transform((_, originalValue) => {
  return isDate(originalValue) ? originalValue : parse(originalValue, 'yyyy-MM-dd', new Date());
});
